module.exports = __webpack_public_path__ + "img/Dusshera.e0095b90.jpeg";